// extracted by mini-css-extract-plugin
export var oneRowAttachmentPreviews = "dapZe";
export var plusMoreNumber = "evkUo";
export var shortWellHeight = "qAePI";
export var shortWellLineHeight = "BzoU5";
export var wellHeight = "Jc4VX";